import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"10px","text-align":"left"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { style: {"padding":"20px"} }

import axios from 'axios';
import { ref, reactive } from 'vue' 
import { layer } from '@layui/layer-vue'
import { allPassageCategory, addPassageCategory, delPassageCategory,getConfig,setConfig } from '../../api'
  

export default /*#__PURE__*/_defineComponent({
  __name: 'setup',
  setup(__props) {

const  requestAddress= ref("http://192.168.5.99:5000/rolechat/reset_characters");

const  updateRole=()=>{
  const data = {
    reset:true, 
      };
      try {
 
        // 发送 POST 请求
          axios.post(requestAddress.value, data).then(response => {
             var data=response.data;
             if(data.code==0){
              layer.msg("刷新成功");
             }else{
              layer.msg("刷新失败");
             }

            
          }) .catch(error => {
              console.error('Error:', error);
              layer.msg("网络异常");
            });

          } catch (error) {
        // 处理请求失败
        layer.msg("网络异常");
      }
 
}


//节点分类
const loading = ref(false);
  
  const dataSource = ref([]);
  
  const selectedKeys = ref([]);
  
  const page = reactive({ current: 1, limit: 10, total: 0 });
  
  const columns = ref([
    { title: "序号", key: "id", align: "center" },
    { title: "名称", key: "categoryName", align: "center" },
    { title: "首页显示", key: "show", align: "center", customSlot: "show"  }, 
    { title: "排序", key: "px", align: "center"},
    { title: "添加时间", key: "addTime", align: "center" },
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
  ]);
  
  const getAllPassageCategory = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit};
    allPassageCategory(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllPassageCategory();


  const change = (page: any) => {
    getAllPassageCategory();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
  
 

  
  const passageCategory = reactive({
    id:0,
    categoryName: "",
    px: 0, 
    show:0,
  })
  
  const delePassageCategory = (row: any) => {
    var data={"id":row.id}
  
    delPassageCategory(JSON.stringify(data)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllPassageCategory();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })

}


  
  const updatePassageCategory = (row: any) => {
    passageCategory.id = row.id;
    passageCategory.categoryName = row.categoryName;
    passageCategory.px = row.px;
    passageCategory.show = row.show;
    
  
    visible11.value = !visible11.value;
  }
  
  const layFormRef11 = ref();
  
  const visible11 = ref(false);
   
  
  const changePassageCategory = () => {
    passageCategory.id = 0;
    passageCategory.categoryName = "";
    passageCategory.px = 0;  
    visible11.value = !visible11.value;
  }
  
  const action11 = ref([
    {
      text: "确认",
      callback: () => {
        addPassageCategory(JSON.stringify(passageCategory)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllPassageCategory();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
      }
    },
    {
      text: "取消",
      callback: () => {
        visible11.value = false;
  
  
      }
    }
  ])

  //基本配置
  const comfigdata = reactive({
    pictureUrl: "", 
    convertUrl:"",
	isVerification:0,
	videoAddress:"",
	isVerif:false,
	 
 
  })
  
  
  //视频验证开关 
    const changeIsVerification =( val: any ) =>{ 
		 if(val){
			 comfigdata.isVerification=1;
		 }else{
			  comfigdata.isVerification=0;
		 }
		
    }
  //提交信息
  const addConfig=()=>{ 
    setConfig(JSON.stringify(comfigdata)).then((res: any) => {
          if (res != "" && res.code == 0) {  
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        }) 
  }


  const fingConfig=()=>{
    getConfig().then((res: any) => {
          if (res != "" && res.code == 0) {  
			  comfigdata.isVerif=res.data.isVerification==1?true:false;
              comfigdata.pictureUrl=res.data.pictureUrl;
            comfigdata.videoAddress=res.data.videoAddress;
            comfigdata.convertUrl=res.data.convertUrl;
         
          }
        }) 
  }

  
  fingConfig();


return (_ctx: any,_cache: any) => {
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_switch = _resolveComponent("lay-switch")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_field = _resolveComponent("lay-field")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_radio = _resolveComponent("lay-radio")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_field, { title: "基本配置" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form, {
                      model: comfigdata,
                      pane: true,
                      isLabelTooltip: "",
                      tooltipProps: true
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_form_item, {
                          label: "图片域名",
                          prop: "pictureUrl"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_input, {
                              modelValue: comfigdata.pictureUrl,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((comfigdata.pictureUrl) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_lay_form_item, {
                          label: "代理服务器",
                          prop: "convertUrl"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_input, {
                              modelValue: comfigdata.convertUrl,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((comfigdata.convertUrl) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_lay_form_item, {
                          label: "视频验证",
                          prop: "isVerif"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_switch, {
                              modelValue: comfigdata.isVerif,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((comfigdata.isVerif) = $event)),
                              onChange: changeIsVerification
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        (comfigdata.isVerif)
                          ? (_openBlock(), _createBlock(_component_lay_form_item, {
                              key: 0,
                              label: "视频地址",
                              prop: "videoAddress"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_lay_input, {
                                  modelValue: comfigdata.videoAddress,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((comfigdata.videoAddress) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_lay_form_item, { style: {"text-align":"center"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_button, {
                              type: "primary",
                              onClick: addConfig
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("提交")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_lay_col, { md: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_field, { title: "AI设置" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_form_item, {
                          label: "请求地址",
                          prop: "requestAddress"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_input, {
                              modelValue: requestAddress.value,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((requestAddress).value = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_lay_form_item, { style: {"text-align":"center"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_button, {
                              type: "primary",
                              onClick: updateRole
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("更新角色")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_lay_col, { md: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_field, { title: "节点分类" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_lay_button, {
                        size: "sm",
                        onClick: changePassageCategory,
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("新增")
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_lay_table, {
                      page: page,
                      height: '100%',
                      columns: columns.value,
                      loading: loading.value,
                      "data-source": dataSource.value,
                      "selected-keys": selectedKeys.value,
                      "onUpdate:selectedKeys": _cache[5] || (_cache[5] = ($event: any) => ((selectedKeys).value = $event)),
                      onChange: change,
                      onSortChange: sortChange
                    }, {
                      operator: _withCtx(({ row }) => [
                        _createVNode(_component_lay_button, {
                          size: "xs",
                          type: "primary",
                          onClick: ($event: any) => (updatePassageCategory(row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("编辑")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_lay_button, {
                          size: "xs",
                          type: "primary",
                          onClick: ($event: any) => (delePassageCategory(row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("删除")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      show: _withCtx(({ row }) => [
                        (row.show==0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "显示"))
                          : (row.show==1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "不显示"))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['350px', '330px'],
      btn: action11.value,
      title: "添加/修改分类节点"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_lay_form, {
            model: passageCategory,
            ref_key: "layFormRef11",
            ref: layFormRef11
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "名称",
                prop: "categoryName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: passageCategory.categoryName,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((passageCategory.categoryName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "排序",
                prop: "px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: passageCategory.px,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((passageCategory.px) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "显示首页",
                prop: "show"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_radio, {
                    modelValue: passageCategory.show,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((passageCategory.show) = $event)),
                    name: "show",
                    value: 0,
                    label: "显示"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_lay_radio, {
                    modelValue: passageCategory.show,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((passageCategory.show) = $event)),
                    name: "show",
                    value: 1,
                    label: "不显示"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})